const warned = new Set<string>();

export function warnCosmeticFallback(kind: string, id: string): void {
  const key = `${kind}:${id}`;
  if (warned.has(key)) return;
  warned.add(key);
  console.warn(`[Cosmetics] Unknown ${kind} "${id}"; using base appearance fallback`);
}
